module.exports = __webpack_public_path__ + "static/media/Orbit-echostar-xvii.48e8e449.png";